import {enforce} from "vest";

export function numberGreater0(value: any) {
  enforce(value).message('validator.number_greater_0').greaterThan(0);
}
